module.exports = __webpack_public_path__ + "img/award.3d06b0ba.svg";